// helmet-async v3 + React 19 cuma tambah tag, tak ganti default index.html/prerender (data-seo-default).
// Buang tag default bila page render tag yang sama supaya tiada duplicate.
const LD = 'script[type="application/ld+json"]';

const keyOf = (el) => {
  if (el.tagName === 'TITLE') return 'title';
  if (el.tagName === 'LINK') return el.getAttribute('rel') === 'canonical' ? 'canonical' : null;
  if (el.tagName === 'SCRIPT') {
    if (el.type !== 'application/ld+json') return null;
    try { return `ld:${JSON.parse(el.textContent)['@type']}`; } catch { return null; }
  }
  return el.getAttribute('name') || el.getAttribute('property');
};
const idOf = el => `${el.tagName}|${keyOf(el)}`;

const stash = new Map();

function sweep() {
  const head = document.head;
  // React 19 hoist meta/title/link ke head, tapi JSON-LD kekal dalam body
  const liveEls = [...head.children, ...document.querySelectorAll(LD)].filter(el => !el.hasAttribute('data-seo-default'));
  const live = new Set(liveEls.map(idOf));
  head.querySelectorAll('[data-seo-default]').forEach(el => {
    const k = idOf(el);
    if (!live.has(k)) return;
    if (el.tagName !== 'SCRIPT') stash.set(k, el);
    el.remove();
  });
  // Pulangkan default bila page baru tiada tag itu (navigasi dalam app)
  stash.forEach((el, k) => {
    if (!live.has(k)) { stash.delete(k); head.appendChild(el); }
  });
}

export function startHeadDedupe() {
  sweep();
  const obs = new MutationObserver(sweep);
  obs.observe(document.head, { childList: true });
  obs.observe(document.body, { childList: true, subtree: true });
}
